<div class="flex flex-col gap-4 justify-between">
  <div class="flex flex-col gap-3">
    <div class="flex items-center justify-between">
      <p class="text-xs text-gray-500 dark:text-gray-400">
        {{ sortedOptions.length }} options
      </p>
      <button
        type="button"
        (click)="startAddOption($event)"
        class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-xs font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
      >
        <lucide-icon [size]="14" [name]="PencilIcon"></lucide-icon>
        Add option
      </button>
    </div>

    <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-xs">
        <thead class="bg-gray-50 dark:bg-gray-800/40">
          <tr>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300">ID</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300 w-[420px] min-w-[360px]">Option Name</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Price</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Max Qty</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Category</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Min Spend</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Description</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Info Message</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-300">Actions</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
          @if (isFormVisible && formMode === 'add') {
            <tr class="bg-gray-50 dark:bg-gray-900/40">
              <ng-container *ngTemplateOutlet="optionFormTemplate"></ng-container>
            </tr>
          }
          @for (option of sortedOptions; track option.id) {
            <tr class="align-top" [ngClass]="{ 'bg-blue-50 dark:bg-blue-900/10': isFormVisible && formMode === 'edit' && editingOptionId === option.id }">
              <td class="px-3 py-2 text-gray-500 dark:text-gray-400">{{ option.id }}</td>
              <td class="px-3 py-2 text-gray-700 dark:text-gray-300 w-[420px] min-w-[360px]">
                <div class="font-medium text-gray-900 dark:text-white/90">{{ option.name }}</div>
              </td>
              <td class="px-3 py-2 whitespace-nowrap text-gray-700 dark:text-gray-300">
                @if (option.price !== null) {
                  {{ option.price | currency:'GBP':'symbol':'1.2-2':'en-GB' }}
                }
              </td>
              <td class="px-3 py-2 whitespace-nowrap text-gray-700 dark:text-gray-300">
                {{ option.max_quantity ?? '' }}
              </td>
              <td class="px-3 py-2 whitespace-nowrap text-gray-700 dark:text-gray-300">
                {{ option.category || 'Full Price' }}
              </td>
              <td class="px-3 py-2">
                <span
                  [class]="option.counts_toward_minimum_spend === false ?
                    'rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-900/40 dark:text-amber-300' :
                    'rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300'"
                >
                  {{ option.counts_toward_minimum_spend === false ? 'No' : 'Yes' }}
                </span>
              </td>
              <td class="px-3 py-2 text-gray-600 dark:text-gray-400">
                <div class="max-w-[160px] truncate">
                  {{ option.description || '' }}
                </div>
              </td>
              <td class="px-3 py-2 text-gray-600 dark:text-gray-400">
                <div class="max-w-[160px] truncate">
                  {{ option.info_message || '' }}
                </div>
              </td>
              <td class="px-3 py-2">
                <div class="flex items-center justify-end gap-2">
                  <button
                    type="button"
                    (click)="editOption(option, $event)"
                    class="text-gray-500 hover:text-primary-600 dark:text-gray-400 dark:hover:text-primary-500"
                    title="Edit option"
                  >
                    <lucide-icon size="16" [name]="PencilIcon"></lucide-icon>
                  </button>
                  <button
                    type="button"
                    (click)="openOptionUsage(option, $event)"
                    class="text-gray-500 hover:text-primary-600 dark:text-gray-400 dark:hover:text-primary-500"
                    title="View usage"
                  >
                    <lucide-icon size="16" [name]="InfoIcon"></lucide-icon>
                  </button>
                  @if (!option.category || option.category === 'Full Price') {
                    <button
                      type="button"
                      (click)="openTierPricing(option, $event)"
                      [title]="getTierDisabledReason(option) || 'Configure tiered pricing'"
                      [disabled]="!!getTierDisabledReason(option)"
                      [class]="getTierDisabledReason(option)
                        ? 'cursor-not-allowed text-gray-900 dark:text-gray-200'
                        : (hasTierConfig(option)
                          ? 'text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300'
                          : 'text-gray-900 hover:text-gray-700 dark:text-gray-200 dark:hover:text-white')"
                    >
                      <lucide-icon size="16" [name]="TierIcon"></lucide-icon>
                    </button>
                  }
                  <button
                    type="button"
                    (click)="openPricingCalendar(option.id)"
                    class="relative text-gray-500 hover:text-primary-600 dark:text-gray-400 dark:hover:text-primary-500"
                    [title]="option.has_daily_prices ? 'Manage daily pricing' : 'Set up daily pricing'"
                  >
                    <lucide-icon size="16" [name]="CalendarIcon" [class]="option.has_daily_prices ? 'text-green-600 dark:text-green-500' : ''"></lucide-icon>
                    @if (option.has_daily_prices) {
                      <span class="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center w-2 h-2 bg-green-500 rounded-full"></span>
                    }
                  </button>
                  <button
                    type="button"
                    (click)="remove(option)"
                    class="text-gray-500 hover:text-red-600 dark:text-gray-400 dark:hover:text-red-500"
                    title="Delete option"
                  >
                    <lucide-icon size="16" [name]="XIcon"></lucide-icon>
                  </button>
                </div>
              </td>
            </tr>
            @if (isFormVisible && formMode === 'edit' && editingOptionId === option.id) {
              <tr class="bg-gray-50 dark:bg-gray-900/40">
                <ng-container *ngTemplateOutlet="optionFormTemplate"></ng-container>
              </tr>
            }
          }
          @if (!sortedOptions.length && !(isFormVisible && formMode === 'add')) {
            <tr>
              <td colspan="9" class="px-3 py-4 text-sm text-gray-500 dark:text-gray-400">
                No options yet. Use "Add option" to create one.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <ng-template #optionFormTemplate>
      <td colspan="9" class="px-0">
        <div class="mt-3 w-full rounded-lg bg-white p-4 dark:bg-gray-800/40">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <div>
              <h4 class="text-sm font-medium text-gray-800 dark:text-gray-200">
                {{ formMode === 'edit' ? 'Editing option' : 'Add option' }}
              </h4>
              @if (formMode === 'edit') {
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ editingOption?.name || '' }}</p>
              }
            </div>
          </div>
          <div class="mt-3 flex flex-wrap gap-3">
            <div class="flex-1 min-w-[200px]">
              <app-text-input
                [control]="nameControl"
                name="name"
                label="Option name"
                placeholder="Option name"
              ></app-text-input>
            </div>

            <div class="flex-1 min-w-[180px]">
              <app-text-input
                [control]="priceControl"
                name="price"
                label="Price (optional)"
                placeholder="Price (optional)"
                type="text"
                [mask]="'separator.2'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
                prefix="£"
              ></app-text-input>
            </div>

            <div class="w-32 min-w-[120px]">
              <app-text-input
                [control]="optionForm.controls.max_quantity"
                name="max_quantity"
                label="Max qty (optional)"
                placeholder="e.g. 50"
                type="number"
                [clearable]="true">
              </app-text-input>
            </div>
          </div>

          <div class="mt-3">
            <app-text-input
              [control]="optionForm.controls.description"
              name="description"
              label="Description (optional)"
              placeholder="e.g. Short description">
            </app-text-input>
          </div>

          <div class="mt-3">
            <app-text-input
              [control]="optionForm.controls.info_message"
              name="info_message"
              label="Info message (optional)"
              placeholder="e.g. “When 70 pizzas are purchased...”">
            </app-text-input>
          </div>

          <div class="mt-3 flex flex-wrap gap-3">
            <div class="min-w-[240px] flex-1">
              <app-date-picker
                [control]="optionForm.controls.available_from"
                [name]="'option_available_from'"
                [label]="'Available From (optional)'"
              ></app-date-picker>
            </div>
            <div class="min-w-[240px] flex-1">
              <app-date-picker
                [control]="optionForm.controls.available_until"
                [name]="'option_available_until'"
                [label]="'Available Until (optional)'"
                [minDate]="optionForm.controls.available_from.value || undefined"
              ></app-date-picker>
            </div>
          </div>

          <div class="mt-3 flex flex-wrap items-center gap-3">
            <div class="flex-1 min-w-[200px]">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Pricing category</label>
              <select
                class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200"
                [formControl]="categoryControl">
                @for (category of categoryChoices; track category) {
                  <option [value]="category">{{ category }}</option>
                }
              </select>
            </div>
            <div class="flex items-center pt-6">
              <label class="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input type="checkbox" class="rounded border-gray-300 text-primary-600 focus:ring-primary-500 dark:bg-gray-800 dark:border-gray-600" [formControl]="countsControl">
                Counts toward minimum spend
              </label>
            </div>
          </div>

          @if (error) {
            <div class="mt-2 text-sm text-red-600 dark:text-red-400">{{ error }}</div>
          }

          <div class="mt-4 flex flex-wrap items-center gap-2">
            <button
              type="button"
              (click)="formMode === 'edit' ? updateOption($event) : addOption($event)"
              class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
            >
              {{ formMode === 'edit' ? 'Update' : 'Add' }}
            </button>
            <button
              type="button"
              (click)="cancelForm()"
              class="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-100 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
            >
              Cancel
            </button>
          </div>

          <div class="mt-3 text-xs text-gray-500 dark:text-gray-400">
            <span class="inline-flex items-center">
              <lucide-icon class="mr-1" [name]="CircleAlert"></lucide-icon>
              Option prices will be added to the base product price when selected
            </span>
          </div>
        </div>
      </td>
    </ng-template>
  </div>

@if (optionUsageDetails) {

  <app-modal
    [title]="optionUsageContext === 'delete' ? 'Cannot Delete Option' : 'Option Usage'"
    [show]="!!optionUsageDetails"
    [closeButtonLabel]="'Close'"
    [confirm]="false"
    (onClose)="closeOptionUsageModal()"
  >
    <div class="space-y-4">
      @if (optionUsageDetails.event_count > 0) {
        <p class="text-sm text-gray-700 dark:text-gray-300">
          @if (optionUsageContext === 'delete') {
            This option cannot be deleted because it is currently being used in <strong>{{ optionUsageDetails.event_count }}</strong> event(s):
          } @else {
            {{ optionUsageOption?.name || 'This option' }} is currently used in <strong>{{ optionUsageDetails.event_count }}</strong> event(s):
          }
        </p>

        <div class="max-h-60 overflow-y-auto rounded-lg border border-gray-200 dark:border-gray-700">
          <table class="min-w-full text-sm">
            <thead class="bg-gray-50 dark:bg-gray-800/40">
              <tr>
                <th class="px-4 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Event</th>
                <th class="px-4 py-2 text-left font-medium text-gray-600 dark:text-gray-300">Date</th>
                <th class="px-4 py-2 text-right font-medium text-gray-600 dark:text-gray-300">Open</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
              @for (event of optionUsageDetails.events; track event.id) {
                <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                  <td class="px-4 py-3">
                    <a [href]="'/events/' + event.id"
                       target="_blank"
                       class="font-medium text-gray-900 hover:text-brand-600 dark:text-white dark:hover:text-brand-400">
                      {{ event.name }}
                    </a>
                    <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      @if (event.reference) {
                        Ref: {{ event.reference }}
                      } @else {
                        ID: {{ event.id }}
                      }
                    </div>
                  </td>
                  <td class="px-4 py-3 text-gray-500 dark:text-gray-400">
                    {{ event.date || '—' }}
                  </td>
                  <td class="px-4 py-3 text-right">
                    <a [href]="'/events/' + event.id"
                       target="_blank"
                       class="inline-flex items-center gap-1 text-gray-500 hover:text-brand-600 dark:text-gray-400 dark:hover:text-brand-400">
                      View
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                      </svg>
                    </a>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (optionUsageContext === 'delete') {
          <p class="text-sm text-gray-600 dark:text-gray-400">
            To delete this option, please remove it from these events first.
          </p>
        }
      } @else {
        <p class="text-sm text-gray-600 dark:text-gray-400">
          {{ optionUsageOption?.name || 'This option' }} is not used in any events yet.
        </p>
      }
    </div>
  </app-modal>
}

@if (hasTierModal) {
  <app-modal
    title="Tiered pricing"
    [show]="hasTierModal"
    [closeButtonLabel]="'Close'"
    [confirm]="false"
    [showFooter]="false"
    (onClose)="closeTierPricing()"
  >
    <div class="space-y-4">
      <div>
        <p class="text-sm text-gray-700 dark:text-gray-300">
          Configure tiered pricing for <strong>{{ tierPricingOption?.name }}</strong>. Remaining quantity after full + complimentary is priced at half.
        </p>
      </div>

      <div class="space-y-4">
        <div class="flex flex-wrap items-end gap-3">
          <div class="flex-1 min-w-[200px]">
            <app-text-input
              [control]="tierForm.controls.tier_full_limit"
              name="tier_full_limit"
              label="Step 1: Full price quantity"
              placeholder="e.g. 70"
              type="number">
            </app-text-input>
          </div>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Quantity billed at full price before complimentary tier starts.
          </p>
        </div>

        <div class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-600 dark:border-gray-700 dark:bg-gray-800/40 dark:text-gray-300">
          {{ tierFlowText }}
        </div>

        @if (!canSelectTierOptions) {
          <div class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-700 dark:border-amber-900/40 dark:bg-amber-900/20 dark:text-amber-200">
            Create Complimentary and Half Price options to enable tiered pricing.
          </div>
        }

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="rounded-lg border border-gray-200 p-3 dark:border-gray-700">
            <div class="text-xs font-medium text-gray-600 dark:text-gray-300 uppercase mb-2">Step 2: Complimentary tier</div>
            <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">
              Next items are free until this quantity is reached.
            </p>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Complimentary option</label>
            <select
              class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200"
              [formControl]="tierForm.controls.tier_complimentary_option_id">
              @if (!tierComplimentaryOptions.length) {
                <option [ngValue]="null">No complimentary options available</option>
              } @else {
                <option [ngValue]="null">Select complimentary option</option>
                @for (option of tierComplimentaryOptions; track option.id) {
                  <option [ngValue]="option.id">{{ option.name }}</option>
                }
              }
            </select>
            <div class="mt-3">
              <app-text-input
                [control]="tierForm.controls.tier_complimentary_limit"
                name="tier_complimentary_limit"
                label="Complimentary quantity"
                placeholder="e.g. 50"
                type="number">
              </app-text-input>
            </div>
          </div>

          <div class="rounded-lg border border-gray-200 p-3 dark:border-gray-700">
            <div class="text-xs font-medium text-gray-600 dark:text-gray-300 uppercase mb-2">Step 3: Half price tier</div>
            <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">
              Any items beyond Full + Complimentary are half price.
            </p>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Half price option</label>
            <select
              class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200"
              [formControl]="tierForm.controls.tier_half_option_id">
              @if (!tierHalfOptions.length) {
                <option [ngValue]="null">No half price options available</option>
              } @else {
                <option [ngValue]="null">Select half price option</option>
                @for (option of tierHalfOptions; track option.id) {
                  <option [ngValue]="option.id">{{ option.name }}</option>
                }
              }
            </select>
          </div>
        </div>
      </div>

      @if (tierPreviewText) {
        <div class="text-xs text-gray-500 dark:text-gray-400">
          {{ tierPreviewText }}
        </div>
      }

      @if (tierError) {
        <div class="text-sm text-red-600 dark:text-red-400">{{ tierError }}</div>
      }

      <div class="flex flex-wrap items-center gap-2">
        <button
          type="button"
          (click)="saveTierPricing()"
          [disabled]="tierForm.invalid || !canSelectTierOptions"
          class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
        >
          Save tiered pricing
        </button>
        <button
          type="button"
          (click)="resetTierPricing()"
          [disabled]="!tierPricingOption || !hasTierConfig(tierPricingOption)"
          class="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-100 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
        >
          Reset tiered pricing
        </button>
        <button
          type="button"
          (click)="closeTierPricing()"
          class="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
        >
          Cancel
        </button>
      </div>
    </div>
  </app-modal>
}
